import dndgFilters from '../dndg/helpers/filters';

export function yesNo(value: boolean) {
    return value? 'Sì' : 'No';
}

export function twoDigits(value: number) {
	let res: string = value.toString();
	if (value < 10) {
		res = '0' + value.toString(); 
	}
    return res;
}

export default {
	// Filters
	yesNo,
	twoDigits,
	
	...dndgFilters
}



// WEBPACK FOOTER //
// ./src/global/filters.ts